<script setup>
import { useReadinessStore } from '../stores';
import AppCard from './layouts/AppCard.vue';
const readinessStore = useReadinessStore();

if (!readinessStore.sortedActivities.length) {
  readinessStore.fetchActivities()
}

</script>
<template>
  <div class="mb-20 md:mb-64 grid grid-cols-1 md:grid-cols-3">
    <div v-for="activity in readinessStore.sortedActivities">
      <AppCard :header="activity.title"
        :body="`${activity.description}`"/>
    </div>
  </div>
</template>